'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _I18n = require('I18n.React');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function VisitorTimeout(_ref) {
  var visitorName = _ref.visitorName;

  return _react2.default.createElement(
    'div',
    { className: 'm-top-2' },
    _react2.default.createElement(
      'div',
      { className: 'chat-message-content' },
      _react2.default.createElement(
        'div',
        { className: 'chat-message-announce timeout-marker text-center' },
        _react2.default.createElement(
          _Small2.default,
          null,
          _react2.default.createElement(_I18n.FormattedHTMLMessage, {
            message: 'chat.visitorAway',
            options: { visitorName: visitorName }
          })
        )
      )
    )
  );
}

VisitorTimeout.propTypes = {
  visitorName: _react.PropTypes.string.isRequired
};

exports.default = VisitorTimeout;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.133/js/components/labels/VisitorTimeoutLabel.js
// module id = 409
// module chunks = 0 1